import moment from "moment";
import React, { Component } from "react";
import { Table } from "react-bootstrap";
import Modal from "../../components/Modal";
import { samplesByOfferingCells } from "../../libs/services";

class SelectSamples extends Component{
    constructor(props){
        super(props);

        this.openModal = this.openModal.bind(this);
        this.openSamplesValidation = this.openSamplesValidation.bind(this);
        this.onClear = this.onClear.bind(this);

        this.state = {
            samples:[]
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    async openModal(id){
        var response = await samplesByOfferingCells(id);
        if(response){
            if(response.length > 1){
                this.setState({samples:response});
                this.modal.handleShow();
            }else{
                this.openSamplesValidation(response[0].id);
            }
            
        }
    }

    openSamplesValidation(id, e = null){
        if(e !== null){
            e.preventDefault();
        }

        this.props.history.push('/cell_bank/results/'+id);

    }

    onClear(){
        this.setState({samples:[]});
    }

    render(){
        return(
            <Modal
                title="Selección de Muestra"                
                clear={this.onClear}
                onRef={ref => this.modal = ref}
            >
                <div className="row">
                    <div className="col-xs-12">
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>Muestra</th>
                                    <th>Tipo</th>
                                    <th>Fecha</th>
                                    <th>Lugar de Colecta</th>
                                    <th>Estatus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.samples.map((sample, i)=>
                                    <tr key={i}>
                                        <td>
                                            <a href="#"  onClick={(e)=>this.openSamplesValidation(sample.id, e)}>
                                                {sample.number}
                                            </a>   
                                        </td>
                                        <td>{sample.type}</td>
                                        <td>{moment(sample.timestamp).format('DD/MM/YYYY HH:mm')}</td>
                                        <td>{sample.convoke_place}</td>
                                        <td>
                                            {sample.status !== null ? 
                                                sample.status == "PENDING" ? "PENDIENTE DE VALIDAR" 
                                                : sample.status == "ACCEPTED" ? "ACEPTADA"
                                                : sample.status == "REJECT" ? "RECHAZADA"
                                                : sample.status: ""
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default SelectSamples;